export default __webpack_public_path__ + "static/media/domo.1a921d47.svg";